<template>
  <v-card
    class="flex-grow-1"
    rounded="lg"
    outlined>
    <v-container>
      <v-row>
        <v-col cols="12" md="12" class="pt-0">
          <h1 class="text-md-h5 font-weight-bold">
            <router-link :to="{ name: 'JobdetailCompany', query: { jobid: job.job_id } }">
              {{ job.job_name }}
            </router-link>
          </h1>
          <div class="my-3">
            <v-chip
              class="mr-1 mb-1"
              color="primary"
              small
              dark>
              <v-icon left small>
                mdi-map-marker
              </v-icon>
              {{ job.job_location }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="orange"
              small
              dark>
              <v-icon left small>
                mdi-av-timer
              </v-icon>
              {{ job.job_type }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="deep-orange"
              small
              dark>
              <v-icon left small>
                mdi-cash-multiple
              </v-icon>
              {{ job.job_salary | rupiahformat }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="red darken-4"
              small
              dark>
              <v-icon left small>
                mdi-calendar-range
              </v-icon>
              {{ job.job_valid }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="success"
              small
              dark>
              <v-icon left small>
                mdi-account-tie
              </v-icon>
              {{ job.jum }} applicant
            </v-chip>
          </div>
          <div v-text="job.job_preview"></div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import qs from 'qs';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';
import Alertsp from './Alert.vue';

export default {
  props: ['job'],
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      apply: false,
      save: false,
    },
    appconfirm: {
      modal: false,
      title: 'Apply for job',
      text: 'Only registered job seekers can apply this job, please Sign Up and Sign In as a jobseeker first. Thank you',
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    isapply: false,
    issave: false,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjob',
      'usersjob',
    ]),
  },
  mounted() {
    this.isapply = this.userjob.includes(this.job.job_id);
    this.issave = this.usersjob.includes(this.job.job_id);
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
  },
  methods: {
    test() {
      console.log('test method');
    },
  },
  components: {
    Alertsp,
  },
};
</script>